import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import Accommodation from '../../../images/Accomodation.png'
import { Container, Card, Button, Form , Col, Row, Carousel} from 'react-bootstrap';

import {FaSearch, FaArrowLeft, FaArrowRight} from 'react-icons/fa'

import search from '../../../images/search.svg'
import acc1 from '../../../images/acc1.png'
import acc2 from '../../../images/acc2.png'
import acc3 from '../../../images/acc3.png'
import star from '../../../images/star.svg'
import star2 from '../../../images/Star-2.svg'
import kruger from '../../../images/kuger-park.png'
import kongou from '../../../images/kogou-falls.png'
import masai from '../../../images/masal-reserve.png'
import frame from '../../../images/Frame-1.svg'
import nigeria from '../../../images/Nigeria.png'
import rwanda from '../../../images/Rwanda.png'
import gabon from '../../../images/Gabon.png'
import ghana from '../../../images/Ghana.png'
import kenya from '../../../images/Kenya.png'
import sa from '../../../images/SA.png'
import country1 from '../../../images/country1.png'
import country2 from '../../../images/country2.png'
import country3 from '../../../images/country3.png'
import country4 from '../../../images/country4.png'
import country5 from '../../../images/country5.png'
import country6 from '../../../images/country6.png'


const UserAcc = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false)
    } else{

    setValidated(true);
    navigate('/user-booking')}
  };
 


  const handleSubscribeSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false)
    } else{

    setValidated(true);
    navigate('/usersubscribe')}
  };
 
  const CustomPrevIcon = ({ onClick }) => (
    <div className="custom-prev-icon" onClick={onClick}>
      <FaArrowLeft/>
    </div>
  );
  
  const CustomNextIcon = ({ onClick }) => (
    <div className="custom-next-icon" onClick={onClick}>
      <FaArrowRight />
    </div>
  );
  return (
    <div>
     
     
      <Card className="text-white border-0" style={{borderRadius:'none'}}>
      <Card.Img src={Accommodation} alt="accomodation" style={{minHeight:'370px',maxHeight:'700px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-sm-5 py-md-5 '>
        <div className='mx-auto py-md-4 my-lg-5 px-md-3 px-1 py-5 align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none', maxWidth:'45rem'}}>
        <h1 className='acc-overlay-header'>Need a place to stay for your vacations?</h1>
        <Card.Text className='mt-3 acc-overlay-info '>
        Explore the magic of adventure with us 
        </Card.Text>
        <div className='mt-sm-5 pt-3 pt-md-3'>
            <Form noValidate validated={validated} onSubmit={handleSubmit} className='p-2 d-flex' style={{background:'#fff'}}>
           
              <img src={search} alt='search'/>
                <Form.Control type="text" placeholder="Search for hotels around you" className='border-0' required/>
             
                <Button type='submit' style={{
 width: '100px',
 
 borderRadius: '8px',
 
 backgroundColor: '#008080'}} >Search</Button>
 
            </Form>
        </div>
        </div>
      </Card.ImgOverlay>
    </Card>
    <Container fluid className='py-5 px-4 px-sm-5'>
        <section className='px-lg-4'>
           <h2 className='acc-section-header mb-4'>Based on Current Location</h2>
           <Row xs={1} md={3} className='d-none d-md-flex'>
            <Col className='mb-3'>
            <Card>
      <Card.Img variant="top" src={acc1} alt='acc1'/>
      <Card.Body className='gap-0'>
        <Card.Title className='card-place' style={{fontWeight:'700'}}>Crown Plaza</Card.Title>
        <Card.Text className='card-location'> Paris
        </Card.Text>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
          <img src={star} alt='star'style={{height:'20px'}}/>
          <p className='my-auto'> 4.5  (56 Reviews)</p>
          </div>
        <Button className='border-0' style={{ backgroundColor: '#008080', width:'100px'}} onClick={()=> navigate('/user-booking')}>Check in</Button>
        </div>
      </Card.Body>
    </Card>
            </Col >
            <Col className='mb-3'>
            <Card style={{}}>
      <Card.Img variant="top" src={acc2} alt='acc2'/>
      <Card.Body className='gap-0'>
        <Card.Title className='card-place' style={{fontWeight:'700'}}>Pyramids of Egypt</Card.Title>
        <Card.Text className='card-location'> Egypt
        </Card.Text>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
          <img src={star2} alt='star' style={{height:'20px'}}/>
          <p className='my-auto'> 4.5  (56 Reviews)</p>
          </div>
        <Button className='border-0' style={{ backgroundColor: '#008080', width:'100px'}} onClick={()=> navigate('/user-booking')}>Check in</Button>
        </div>
      </Card.Body>
    </Card>
            </Col>
            <Col className='mb-3'>
            <Card style={{}}>
      <Card.Img variant="top" src={acc3} alt='acc3'/>
      <Card.Body className='gap-0'>
        <Card.Title className='card-place' style={{fontWeight:'700'}}>The Great Tower</Card.Title>
        <Card.Text className='card-location'> Dubai
        </Card.Text>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
          <img src={star2} alt='star' style={{height:'20px'}}/>
          <p className='my-auto'> 4.5  (56 Reviews)</p>
          </div>
        <Button className='border-0' style={{ backgroundColor: '#008080', width:'100px'}} onClick={()=> navigate('/user-booking')}>Check in</Button>
        </div>
      </Card.Body>
    </Card>
            </Col>
          </Row>
          <Carousel prevIcon={<CustomPrevIcon />} nextIcon={<CustomNextIcon />} className='d-flex d-md-none custom-carousel'  >
      <Carousel.Item interval={1000}>
      <Card>
      <Card.Img variant="top" src={acc1} alt='acc1'/>
      <Card.Body className='gap-0'>
        <Card.Title className='card-place' style={{fontWeight:'700'}}>Crown Plaza</Card.Title>
        <Card.Text className='card-location'> Paris
        </Card.Text>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
          <img src={star} alt='star' style={{height:'20px'}}/>
          <p className='my-auto'> 4.5  (56 Reviews)</p>
          </div>
        <Button className='border-0' style={{ backgroundColor: '#008080', width:'100px'}} onClick={()=> navigate('/user-booking')}>Check in</Button>
        </div>
      </Card.Body>
    </Card>
      </Carousel.Item>
      <Carousel.Item interval={500}>
      <Card style={{}}>
      <Card.Img variant="top" src={acc2} alt='acc2'/>
      <Card.Body className='gap-0'>
        <Card.Title className='card-place' style={{fontWeight:'700'}}>Pyramids of Egypt</Card.Title>
        <Card.Text className='card-location'> Egypt
        </Card.Text>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
          <img src={star2} alt='star' style={{height:'20px'}}/>
          <p className='my-auto'> 4.5  (56 Reviews)</p>
          </div>
        <Button className='border-0' style={{ backgroundColor: '#008080', width:'100px'}} onClick={()=> navigate('/user-booking')}>Check in</Button>
        </div>
      </Card.Body>
    </Card>
      </Carousel.Item>
      <Carousel.Item>
      <Card style={{}}>
      <Card.Img variant="top" src={acc3} alt='acc3'/>
      <Card.Body className='gap-0'>
        <Card.Title className='card-place' style={{fontWeight:'700'}}>The Great Tower</Card.Title>
        <Card.Text className='card-location'> Dubai
        </Card.Text>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
          <img src={star2} alt='star' style={{height:'20px'}}/>
          <p className='my-auto'> 4.5  (56 Reviews)</p>
          </div>
        <Button className='border-0' style={{ backgroundColor: '#008080', width:'100px'}} onClick={()=> navigate('/user-booking')}>Check in</Button>
        </div>
      </Card.Body>
    </Card>
      </Carousel.Item>
    </Carousel>
         
        </section>
        <section className='px-lg-4 mt-5'>
           <h2 className='acc-section-header mb-4'>Hotest Vacation Deals</h2>
           <Row xs={1} md={3} className='d-none d-md-flex'>
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={kruger} alt="kruger" style={{maxHeight:'590px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-5 py-5 '>
        <div className='py-5 py-lg-5 my-lg-5 py-md-3 my-md-3 my-5  align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none'}}>
        <Card.Title className='park' style={{}}>Kruger National Park</Card.Title>
        <Card.Text className='park mt-2'>
       South Africa
        </Card.Text>
        <Card.Text className='mt-5 mt-lg-5 pt-lg-5 mt-md-0 pt-5  park-amount'>
            NGN 180,000
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col >
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={kongou} alt="kongou" style={{maxHeight:'590px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-5 py-5 '>
        <div className='py-5 py-lg-5 my-lg-5 py-md-3 my-md-3 my-5  align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none'}}>
          
        <Card.Title className='park' style={{}}>Kongou Falls</Card.Title>
        <Card.Text className='park mt-2'>
      Gabon
        </Card.Text>
        <Card.Text className='mt-5 pt-5 park-amount'>
            NGN 180,000
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col>
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={masai} alt="masai" style={{maxHeight:'590px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-5 py-5 '>
        <div className='py-5 py-lg-5 my-lg-5 py-md-3 my-md-3 my-5  align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none'}}>
        <Card.Title className='park' style={{}}>Masai Mara National Reserve</Card.Title>
        <Card.Text className='park mt-2'>
       Kenya
        </Card.Text>
        <Card.Text className='mt-5 mt-lg-5 pt-lg-5 mt-md-0 pt-5 park-amount'>
            NGN 180,000
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col>
          </Row>
          <Carousel prevIcon={<CustomPrevIcon />} nextIcon={<CustomNextIcon />} className='d-flex d-md-none custom-carousel' >
      <Carousel.Item interval={1000}>
      <Card className="text-white border-0 ">
      <Card.Img src={kruger} alt="kruger" style={{maxHeight:'590px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-5 py-5 '>
        <div className='py-5 py-lg-5 my-lg-5 py-md-3 my-md-3 my-5  align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none'}}>
        <Card.Title className='park' style={{}}>Kruger National Park</Card.Title>
        <Card.Text className='park mt-2'>
       South Africa
        </Card.Text>
        <Card.Text className='mt-5 mt-lg-5 pt-lg-5 mt-md-0 pt-5  park-amount'>
            NGN 180,000
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item interval={500}>
      <Card className="text-white border-0 ">
      <Card.Img src={kongou} alt="kongou" style={{maxHeight:'590px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-5 py-5 '>
        <div className='py-5 py-lg-5 my-lg-5 py-md-3 my-md-3 my-5  align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none'}}>
          
        <Card.Title className='park' style={{}}>Kongou Falls</Card.Title>
        <Card.Text className='park mt-2'>
      Gabon
        </Card.Text>
        <Card.Text className='mt-5 pt-5 park-amount'>
            NGN 180,000
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item>
      <Card className="text-white border-0 ">
      <Card.Img src={masai} alt="masai" style={{maxHeight:'590px'}}/>
      <Card.ImgOverlay className='text-align-center text-center align-items-center justify-content-around my-5 py-5 '>
        <div className='py-5 py-lg-5 my-lg-5 py-md-3 my-md-3 my-5  align-items-center justify-content-center text-center' style={{background:'none', borderRadius:'none'}}>
        <Card.Title className='park' style={{}}>Masai Mara National Reserve</Card.Title>
        <Card.Text className='park mt-2'>
       Kenya
        </Card.Text>
        <Card.Text className='mt-5 mt-lg-5 pt-lg-5 mt-md-0 pt-5 park-amount'>
            NGN 180,000
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
    </Carousel>
         
        </section>
        <section className='px-lg-4 mt-5'>
           <h2 className='acc-section-header mb-4'>Hotels in popular locations</h2>
          
           <Row xs={1} md={3} className='d-none d-md-flex'>
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={country1} alt="country1" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Nigeria
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col >
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={country2} alt="country2" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Ghana
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col>
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={country3} alt="country3" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       South Africa
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col>
          </Row>
          <Row xs={1} md={3} className='d-none d-md-flex'>
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={country4} alt="country4" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Rwanda
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col >
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={country5} alt="country5" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Kenya
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col>
            <Col className='mb-3'>
            <Card className="text-white border-0 ">
      <Card.Img src={country6} alt="country6" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Gabon
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
            </Col>
          </Row>
          <Carousel prevIcon={<CustomPrevIcon />} nextIcon={<CustomNextIcon />} className='d-flex d-md-none custom-carousel' >
      <Carousel.Item interval={1000}>
      <Card className="text-white border-0 ">
      <Card.Img src={country1} alt="country1" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Nigeria
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item interval={1000}>
      <Card className="text-white border-0 ">
      <Card.Img src={country2} alt="country2" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Ghana
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item interval={1000}>
      <Card className="text-white border-0 ">
      <Card.Img src={country3} alt="country3" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       South Africa
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item interval={1000}>
      <Card className="text-white border-0 ">
      <Card.Img src={country4} alt="country4" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Rwanda
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item interval={1000}>
      <Card className="text-white border-0 ">
      <Card.Img src={country5} alt="country5" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Kenya
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
      <Carousel.Item>
      <Card className="text-white border-0 ">
      <Card.Img src={country6} alt="country6" style={{maxHeight:'370px'}}/>
      <Card.ImgOverlay className=''>
        <div className='d-block justify-content-between p-3 py-md-0' style={{background:'none', borderRadius:'none'}}>
        
        <Card.Text className='park-amount ' style={{fontSize:'38px', marginBottom:'115px'}}>
       Gabon
        </Card.Text>
        <Card.Text className='park pt-5 pt-lg-5 pt-md-0 mt-5 mt-md-0 mt-lg-5' style={{fontSize:'22px', fontWeight:'500'}}>
            50 hotels
        </Card.Text>
        </div>
      </Card.ImgOverlay>
    </Card>
      </Carousel.Item>
    </Carousel>
          <div className='forgot-password text-center justify-content-center mt-2'>
          <Link to="/user-booking" className='forgot-password' style={{fontSize:'20px'}}>Check more locations</Link>
          </div>
        </section>
    </Container>
    <Container fluid style={{background:'#008080'}} className='justify-content-center align-items-center text-align-center p-3 mt-3'>
      <Card style={{background:'none', borderRadius: 'none', maxWidth:'45rem'}}className='border-0 text-align-center p-3 p-md-5 m-auto my-4 '>
      <h3 className='welcome text-white'>Want to stay updated with travel news?</h3>
      <Form className='d-flex text-center justify-content-center mt-3 gap-2' noValidate validated={validated} onSubmit={handleSubscribeSubmit}>
        <Form.Group >
          <Form.Control type='email' placeholder='Enter email address' className='py-2' required/>
        </Form.Group>
        <button type='submit'className='subscribe-button border-0'>Subscribe</button>
      </Form>
      <h6 className='mt-4 text-center unsubscribe'> You can unsubscribe anytime</h6>
      </Card>
    </Container>
    </div>
  )
}

export default UserAcc
